export * from './objekt-nutzungs-list.component';
export * from './objekt-nutzungs-list.component.module';